import { Button, Typography } from '@breetometer/components';
import { ManageDataIcon, MeterTypeIcon } from 'BreetAssets';
import { ImageComponent, type ITablePlainColumn, mapTableWithId, TablePlain, TableTooltip } from 'BreetComponents';
import type { IWalletAddress } from 'BreetHelpers';
import { useMemo } from 'react';

import type { IWalletAddressesTable } from './WalletAddresses.helpers';

const WalletAddressTable = ({
	data,
	onSelect,
	mode = 'saved',
	onDelete,
	onEdit,
	selectedWalletAddress,
}: IWalletAddressesTable) => {
	const walletAddressCol: ITablePlainColumn<IWalletAddress>[] = useMemo(
		() => [
			{
				render: ({ row }) => (
					<Button
						className={`savedwalletaddress_item ${mode === 'saved' ? '' : 'no-pointer button-cancel-transform'}`}
						variant='native'
						type='button'
						onClick={mode === 'saved' ? onSelect?.(row) : undefined}
					>
						<div className='savedwalletaddress_item_left'>
							<ImageComponent
								src={row.avatar}
								alt={row.token}
							/>
							<div className='div-container'>
								<Typography
									as='h6'
									className='color-neutral-50 truncate'
								>
									{row.token} ({row.network}) - {row.label}
								</Typography>
								<Typography className='color-primary-100'>
									<TableTooltip
										enabled={!!row.address}
										message={row.address}
										truncate
									>
										{row.address}
									</TableTooltip>
								</Typography>
							</div>
						</div>
					</Button>
				),
				className: 'wallet-address-cell color-neutral-50',
			},
			{
				render: ({ row }) => (
					<Button
						className={`savedwalletaddress_item ${mode === 'saved' ? '' : 'no-pointer button-cancel-transform'}`}
						variant='native'
						type='button'
						onClick={mode === 'saved' ? onSelect?.(row) : undefined}
					>
						<div className='savedwalletaddress_item_right'>
							{mode === 'saved' ? (
								<MeterTypeIcon
									className='savedwalletaddress_item_selecticon'
									selected={row.address === selectedWalletAddress}
								/>
							) : (
								<>
									<ManageDataIcon
										variant='edit'
										className='cursor_pointer svg-dark svg-dark-outline svg-dark-fill'
										focusable
										title='Edit wallet address'
										aria-label='Edit wallet address'
										role='button'
										tabIndex={0}
										onClick={onEdit?.(row)}
									/>
									<ManageDataIcon
										variant='delete'
										className='cursor_pointer svg-danger-outline'
										focusable
										title='Delete wallet address'
										aria-label='Delete wallet address'
										role='button'
										tabIndex={0}
										onClick={onDelete?.(row)}
									/>
								</>
							)}
						</div>
					</Button>
				),
				className: 'action-cell color-neutral-50',
			},
		],
		[mode, onDelete, onEdit, onSelect, selectedWalletAddress]
	);

	return (
		<TablePlain
			columns={walletAddressCol}
			data={data.map(mapTableWithId)}
			rowClass='bg-primary-500 border-bottom-dark-navy'
			hideHeader
		/>
	);
};

export default WalletAddressTable;
